import _ from 'lodash';

import worldMap from '../../core/map';
import api from '../../api';
import environment from '../../environment';
import translate from '../../core/tools/translate';

const LayerControls = (name) => require('../../controls/index').get(name);

const get = (name, currentMap = worldMap.getCurrent()) => {
    return require('../index').default.get(name, currentMap);
};

class CustomersAction {
    constructor ({ feature, layer, currentMap, name, isAfterSales }) {
        const layerName = isAfterSales ? 'CustomersAfterSales' : 'Customers';

        const turnOnCustomers = () => {
            if (!LayerControls(layerName).check()) {
                LayerControls(layerName).check(true);
            }

            api.general.log.action(environment._getContextEnum(name), 'Show Clientes', JSON.stringify(feature.properties));

            LayerControls(layerName).add(feature.properties.Id, get(name, currentMap));
        };

        const turnOffCustomers = () => {
            LayerControls(layerName).removeHaloSelected(feature.properties.Id);
            return LayerControls(layerName).remove(feature.properties.Id, get(name, currentMap));
        };

        return {
            check: () => LayerControls(layerName).isHaloSelected(feature.properties.Id),
            layer,
            map: currentMap,
            icon: 'icon_bubble_clients',
            off: turnOffCustomers,
            on: turnOnCustomers,
            title: translate('Action.Clients')
        };
    }
}

export default CustomersAction;



// WEBPACK FOOTER //
// ./src/scripts/layers/HaloLayer/CustomersAction.js